import React from 'react';
import { sendChatComposerEmaLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';
const EmaAddPatientComposer = () => {
  return <GenericLeadSyncComposer id={'ema'} title={'EMA'} syncMethod={sendChatComposerEmaLead} />;
};

export default EmaAddPatientComposer;
